import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { Fade } from 'react-awesome-reveal'
import { StaticImage, getImage } from 'gatsby-plugin-image'

import { BgImage } from 'gbimage-bridge'
import { useTheme } from '@material-ui/styles'
import Divider from '../../components/Divider'
import routes from '../../routes'

import IDVerificationIcon from '../../assets/Home/Icons/identity_verification.svg'
import AuthenticationIcon from '../../assets/Home/Icons/authentication_onboarding.svg'
// import KYTIcon from '../../assets/Home/Icons/KYT_KYA.svg'
import CommIcon from '../../assets/Home/Icons/secure_comm.svg'
import SanctionIcon from '../../assets/Home/Icons/sanction_list.svg'

import KYCIcon from '../../assets/Home/Icons/kyc_aml.svg'
import ComplianceIcon from '../../assets/Home/Icons/compliance.svg'

import ImmeSection from '../../sections/Home/02-Imme'
import BusinessSection from '../../sections/Home/03-Business'
// import CTABox from '../../components/CTABox'
import CTALink from '../../components/CTALink'
import CustomFadeSlide from '../../components/RevealAnim/CustomFadeSlide'
// import HeroImage from '../../assets/Home/Images/header_mobile.png'
import ContactUs from '../../components/ContactUs'

import ComingSoonBanner from '../../assets/shared/coming_soon_banner.svg'

const MerchSignupImg = '../../assets/Home/Images/merch_signup2.png'

const useStyles = makeStyles((theme) => ({
  /**
   * || Reusable Components
   * ======================================= */
  sectionTitle: {
    marginBottom: 15,
    maxWidth: 280,

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      maxWidth: 320,
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: 525,
    },
  },
  sectionDescription: {
    maxWidth: 350,

    color: 'rgba(115, 115, 115, 1)',

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      maxWidth: 500,
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: 600,
    },
  },

  /**
   * || Hero Section
   * ======================================= */
  heroBG: {
    position: 'relative',
    display: 'flex',

    top: -48, // Account for the header bar height
    height: 440,
    width: '100%',
    margin: '0px auto',
    maxWidth: theme.custom.maxWidth,
    background: 'white',

    backgroundSize: 'cover',
    backgroundPosition: '60%',
    backgroundRepeat: 'no-repeat',

    [theme.breakpoints.up('tablet')]: {
      alignItems: 'center',

      height: 750,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    },

    [theme.breakpoints.up('desktop')]: {
      paddingTop: 100,
    },
  },
  heroContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '220px auto 0px auto',
    maxWidth: '325px',
    justifyContent: 'center',
    width: '100%',

    [theme.breakpoints.up('tablet')]: {
      alignItems: 'flex-start',
      maxWidth: '664px',
      margin: '0px auto 0px 30px',
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: '730px',
    },
  },
  titleContainer: {
    width: '100%',
  },
  heroText: {
    color: 'black',
    fontSize: 'calc(31px + 0.4vw)',
    textAlign: 'left',
    lineHeight: 'calc(40px + 0.5vw)',

    [theme.breakpoints.up('tablet')]: {
      lineHeight: '60px',
      textAlign: 'left',
      fontSize: 'calc(44px + 0.7vw)',
    },

    [theme.breakpoints.up('desktop')]: {
      lineHeight: '120%',
      width: 750,
      fontSize: 56,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: 24,
    width: 'calc(320px + 1vw)',
    maxWidth: '325px',
    paddingTop: 20,

    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      width: '100%',
      maxWidth: '500px',
    },
  },
  signUpButton: {
    width: '100%',
    marginTop: 5,
    marginBottom: 5,
    fontSize: '16px',
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.up('tablet')]: {
      marginRight: '15px',
      marginTop: 0,
      marginBottom: 0,
      fontSize: '14px',
      height: '50px',
      width: '140px',
      padding: 0,
    },

    [theme.breakpoints.up('desktop')]: {
      width: '150px',
    },
  },

  /**
   * || CycurID Services Section
   * ======================================= */
  servicesSection: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    marginTop: 160,
    marginBottom: 70,

    [theme.breakpoints.up('tablet')]: {
      marginBottom: 110,
    },
  },

  servicesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    marginTop: 30,

    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
      justifyContent: 'center',
      flexWrap: 'wrap',
      width: '100%',

      maxWidth: 680,
    },

    [theme.breakpoints.up('desktopXL')]: {
      marginTop: 45,
      maxWidth: 1200,
      justifyContent: 'space-evenly',
      flexWrap: 'nowrap',
    },
  },
  servicesCard: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',

    textDecoration: 'none',
    color: 'black',

    padding: 12,
    width: 290,
    height: 95,
    marginBottom: 20,

    // background: '#FFFFFF',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: 10,

    textTransform: 'none',

    '&:hover': {
      color: '#2FA43B',
    },

    [theme.breakpoints.up('tablet')]: {
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      textAlign: 'center',

      width: 220,
      height: 190,
      padding: 25,
      margin: 10,
    },
  },
  inactive: {
    cursor: 'default',
    '&:hover': {
      color: 'black',
    },
  },
  serviceIconBG: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    height: 36,
    width: 36,
    marginRight: 25,

    borderRadius: 50,
    background: '#F0F4F8',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)',

    [theme.breakpoints.up('tablet')]: {
      marginRight: 0,
      marginBottom: 12,
      height: 67,
      width: 67,
    },
  },
  serviceIcon: {
    width: 20,
    height: 'auto',

    [theme.breakpoints.up('tablet')]: {
      width: 40,
    },
  },

  comingSoonBanner: {
    position: 'absolute',
    left: 72,
    top: 5,

    width: 85,
    height: 20,

    [theme.breakpoints.up('tablet')]: {
      left: -2,
      top: 10,
    },
  },

  /**
   * || CycurID Applications Section
   * ======================================= */
  applicationsSection: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    marginTop: 180,
    marginBottom: 150,

    overflow: 'hidden',

    [theme.breakpoints.up('tablet')]: {
      marginBottom: 110,
      paddingBottom: 15,
    },
  },
  applicationImage: {
    width: '90%',
    height: 'auto',
    // boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.25)',
    // borderRadius: 10,

    [theme.breakpoints.up('desktop')]: {
      position: 'relative',
      left: '-25%',
      width: 800,

      '& img': {
        width: 800,
        height: '524px',
      },
    },
    [theme.breakpoints.up('1100')]: {
      width: 900,

      '& img': {
        width: 900,
        height: '524px',
      },
    },

    [theme.breakpoints.up('1200')]: {
      width: 1000,

      '& img': {
        width: 1000,
        height: '524px',
      },
    },
    [theme.breakpoints.up('desktopXL')]: {
      left: '-22%',
      width: 1100,
      height: '624px',

      '& img': {
        width: 1100,
        height: '634px',
      },
    },
  },
  applicationContent: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    margin: '0px 10px',
    marginTop: 50,
    width: '100%',
    overflow: 'hidden',
    maxWidth: 1600,

    [theme.breakpoints.up('desktop')]: {
      flexDirection: 'row',
    },
  },

  applicationColumnRight: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',

    [theme.breakpoints.up('desktop')]: {
      justifyContent: 'center',
      height: '100%',
      padding: 0,
      width: 320,
      left: -150,
    },

    [theme.breakpoints.up('1100')]: {
      left: -190,
      width: 400,
    },

    [theme.breakpoints.up('1200')]: {
      left: -190,
      width: 400,
    },

    [theme.breakpoints.up('1300')]: {
      left: -190,
      width: 500,
    },

    [theme.breakpoints.up('desktopXL')]: {
      left: -170,
      width: 520,
    },

    [theme.breakpoints.up('1550')]: {
      left: -170,
      width: 600,
    },
  },
  applicationFeature: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    maxWidth: 360,
    margin: '50px auto 40px auto',

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      maxWidth: 460,
    },

    [theme.breakpoints.up('desktop')]: {
      alignItems: 'flex-start',
      marginTop: 25,
      maxWidth: 450,

      textAlign: 'left',
    },

    [theme.breakpoints.up('desktopXL')]: {
      maxWidth: 850,
    },
  },
  featuresText: {
    color: '#737373',
    fontSize: 12,

    [theme.breakpoints.up('desktop')]: {
      fontSize: 16,
    },

    [theme.breakpoints.up('desktopXL')]: {},
  },
  featuresTitle: {
    marginTop: 10,
    marginBottom: 8,

    [theme.breakpoints.up('tablet')]: {
      fontSize: 16,
    },

    [theme.breakpoints.up('desktop')]: {
      fontSize: 18,
    },

    [theme.breakpoints.up('desktopXL')]: {},
  },
  ctaSection: {
    [theme.breakpoints.up('tablet')]: {
      maxWidth: theme.custom.maxWidth,
      margin: 'auto',
      marginBottom: -165,
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: theme.custom.maxWidth,
      margin: 'auto',
      marginBottom: -40,
    },
    marginBottom: 157,
  },
}))

export default function Home() {
  const classes = useStyles()
  const services = [
    {
      name: 'Identity Verification',
      route: routes.IDENTITY_VERIFICATION,
      icon: (
        <IDVerificationIcon className={classes.serviceIcon} color='#2FA43B' />
      ),
    },
    {
      name: 'Authentication & Onboarding',
      route: routes.AUTH_ONBOARDING,
      icon: (
        <AuthenticationIcon className={classes.serviceIcon} color='#2FA43B' />
      ),
    },
    {
      name: 'Sanction List Screening',
      route: routes.SANCTION_LIST,
      icon: <SanctionIcon className={classes.serviceIcon} color='#2FA43B' />,
    },
    {
      name: 'Secure Communication Tools',
      // route: routes.COMMUNICATION_TOOLS,
      icon: <CommIcon className={classes.serviceIcon} color='#2FA43B' />,
      comingSoon: true,
      inactive: true,
    },
  ]
  const theme = useTheme()

  const { mobileHeader, tabletHeader } = useStaticQuery(
    graphql`
      query {
        tabletHeader: file(
          relativePath: { eq: "Home/Images/header_mobile2.png" }
        ) {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
              width: 1440
              height: 750
            )
          }
        }
        mobileHeader: file(relativePath: { eq: "Home/Images/header2.png" }) {
          childImageSharp {
            gatsbyImageData(
              width: 600
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
      }
    `,
  )

  const sources = [
    {
      ...getImage(mobileHeader),
    },
    {
      ...getImage(tabletHeader),
      media: `(min-width: ${theme.breakpoints.values.tablet}px)`,
    },
  ]
  return (
    <>
      <BgImage
        image={sources}
        Tag='section'
        className={classes.heroBG}
        backgroundColor='#eff3f8'
      >
        <div className={classes.heroContent}>
          <Fade triggerOnce delay={0}>
            {/* <Divider style={{ marginBottom: 12 }} /> */}
            <div className={classes.titleContainer}>
              <Typography variant='h1' className={classes.heroText}>
                Changing How <br />
                Digital Commerce Works Through the{' '}
                <span style={{ color: 'rgba(47, 164, 59, 1)' }}>
                  Power of Digital Identity
                </span>
              </Typography>
            </div>
            <div className={classes.buttonContainer}>
              <CTALink
                className={classes.signUpButton}
                href={process.env.GATSBY_DASHBOARD_SIGNUP_LINK}
                target='_blank'
                rel='noopener'
              >
                Get Started
              </CTALink>

              <CTALink
                className={classes.signUpButton}
                href={routes.CONTACT}
                variant='outline'
              >
                Talk To Sales
              </CTALink>
            </div>
          </Fade>
        </div>
      </BgImage>

      <Fade triggerOnce delay={300}>
        <section className={classes.servicesSection}>
          <Divider style={{ marginBottom: 15 }} />
          <Typography variant='h2' className={classes.sectionTitle}>
            A Comprehensive Solution for Cutting-Edge Businesses
          </Typography>
          <Typography variant='body1' className={classes.sectionDescription}>
            By creating a modernized Digital Identity Management system, CycurID
            enables one solution for a wide array of issues that your business
            needs to address. Explore the variety of specific features CycurID
            delivers:
          </Typography>

          <div className={classes.servicesContainer}>
            <Fade triggerOnce delay={200} cascade duration={600}>
              {services.map((service) => {
                return (
                  <Link
                    key={service.name}
                    className={`${classes.servicesCard} ${
                      service.inactive ? classes.inactive : null
                    }`}
                    to={service.route}
                  >
                    {service.comingSoon && (
                      <ComingSoonBanner className={classes.comingSoonBanner} />
                    )}
                    <div className={classes.serviceIconBG}>{service.icon}</div>
                    <Typography
                      variant='h4'
                      style={{ fontSize: 14 }}
                      component='div'
                    >
                      {service.name}
                    </Typography>
                  </Link>
                )
              })}
            </Fade>
          </div>
        </section>
      </Fade>

      <section className={classes.applicationsSection}>
        <Fade triggerOnce delay={300}>
          <Divider style={{ marginBottom: 15 }} />
          <Typography variant='h2' className={classes.sectionTitle}>
            Agile and Flexible Applications
          </Typography>
          <Typography variant='body1' className={classes.sectionDescription}>
            Knowing your customers is the foundation to modern commerce. CycurID
            fully leverages the power of a secure, persistent Digital Identity
            to create a flexible and comprehensive solution that addresses needs
            across countless facets of your business.
          </Typography>
        </Fade>

        <div className={classes.applicationContent}>
          <CustomFadeSlide delay={0} direction='left'>
            <StaticImage
              className={classes.applicationImage}
              src={MerchSignupImg}
              alt='Dashboard signup form screenshot'
              placeholder='blurred'
              objectFit='fill'
              quality={100}
            />
          </CustomFadeSlide>
          <Fade triggerOnce delay={300}>
            <div className={classes.applicationColumnRight}>
              <div className={classes.applicationFeature}>
                <KYCIcon color='#2FA43B' style={{ height: 45 }} />
                <Typography
                  variant='h4'
                  className={classes.featuresTitle}
                  component='h3'
                >
                  Going Beyond KYC
                </Typography>
                <Typography variant='body2' className={classes.featuresText}>
                  Digital Identity is at the core of many modern issues that
                  slow down businesses on the cutting edge. By addressing the
                  foundational issue rather than creating a patchwork of small
                  fixes, CycurID does more for your company than only doing KYC.
                </Typography>
              </div>
              <div className={classes.applicationFeature}>
                <ComplianceIcon color='#2FA43B' style={{ height: 45 }} />
                <Typography
                  variant='h4'
                  className={classes.featuresTitle}
                  component='h3'
                >
                  Future-Proofed Compliance
                </Typography>
                <Typography variant='body2' className={classes.featuresText}>
                  Don&apos;t settle for hammering square pegs into round holes.
                  Rather than patching over your legacy systems, CycurID helps
                  you address root problems and future-proof your business
                  against next generation digital requirements.
                </Typography>
              </div>
            </div>
          </Fade>
        </div>
      </section>

      <ImmeSection />
      <BusinessSection />

      <Fade triggerOnce fraction={0.3}>
        <div className={classes.ctaSection}>
          <ContactUs />
        </div>
      </Fade>
    </>
  )
}
